module.exports = __webpack_public_path__ + "img/login-top2.28e76bfe.png";